import { render, staticRenderFns } from "./СounterpartiesCreate.vue?vue&type=template&id=ef5ca1f2&"
import script from "./СounterpartiesCreate.vue?vue&type=script&lang=js&"
export * from "./СounterpartiesCreate.vue?vue&type=script&lang=js&"
import style0 from "./СounterpartiesCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports